import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://admin.greendrivemobility.in/api/external/v2/';

export const homeApi = createApi({
  reducerPath: 'homeApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  keepUnusedDataFor: 3600, // Cache for 1 hour
  endpoints: (builder) => ({
    getPartnersAndClients: builder.query({
      query: () => 'public/home/partners-clients',
      transformResponse: (response) => {
        if (response?.success && response?.data) {
          return response.data;
        }
        return response || {};
      },
    }),
    getHomeStats: builder.query({
      query: () => 'public/home/stats',
      transformResponse: (response) => {
        if (response?.success && response?.data) {
          return response.data;
        }
        return response || {};
      },
    }),
    getMapCityStats: builder.query({
      query: () => 'public/home/map-stats',
      transformResponse: (response) => {
        if (response?.success && response?.data) {
          return response.data;
        }
        return response || {};
      },
    }),
  }),
});

export const {
  useGetPartnersAndClientsQuery,
  useGetHomeStatsQuery,
  useGetMapCityStatsQuery,
} = homeApi;
